export const clientDetailMockData = {
  client: {
    id: "cli-2026-001",
    bedrijfsnaam: "Van Dijk Brandveiligheid B.V.",
    klantnummer: "KL-100238",
    status: "actief",
    bezoekadres: "Willemstraat 18, 3011 AD Rotterdam",
    factuuradres: "Postbus 550, 3000 AN Rotterdam",
    kvkNummer: "64328719",
    btwNummer: "NL8542.77.991.B01",
    hoofdcontactpersoon: "Maaike van Dijk",
    telefoon: "+31 10 345 67 89",
    email: "info@vandijkbrandveiligheid.nl",
    klanttype: "opdrachtgever",
    labels: ["Top 50", "BMI", "Onderhoudscontract"],
    documentSamenvatting: {
      totaal: 24,
      verlopenBinnenkort: 2,
      ontbrekend: 1,
    },
    contactSamenvatting: "3 actieve contactpersonen, 1 facturatiecontact",
    moneybirdRelatieId: "MB-REL-445901",
  },
  contacts: [
    {
      id: "ct-1",
      naam: "Maaike van Dijk",
      functie: "Projectleider",
      email: "maaike.vandijk@vandijkbrandveiligheid.nl",
      telefoon: "+31 6 10 22 33 44",
      type: "technisch",
    },
    {
      id: "ct-2",
      naam: "Ruben de Graaf",
      functie: "Financieel medewerker",
      email: "facturen@vandijkbrandveiligheid.nl",
      telefoon: "+31 10 345 67 91",
      type: "facturatie",
    },
    {
      id: "ct-3",
      naam: "Sophie Koster",
      functie: "Facility coördinator",
      email: "s.koster@vandijkbrandveiligheid.nl",
      telefoon: "+31 6 80 19 23 11",
      type: "opdrachtgever",
    },
  ],
  workorders: [
    {
      id: "wb-2026-0142",
      werkbonnummer: "WB-2026-0142",
      titel: "Jaarlijkse BMI onderhoudsronde",
      status: "in-uitvoering",
      geplandeDatum: "2026-03-11",
      uitvoerder: "R. Mulder",
    },
    {
      id: "wb-2026-0113",
      werkbonnummer: "WB-2026-0113",
      titel: "Storing slow-whoop verdieping 2",
      status: "gepland",
      geplandeDatum: "2026-03-10",
      uitvoerder: "S. Meijer",
    },
    {
      id: "wb-2026-0094",
      werkbonnummer: "WB-2026-0094",
      titel: "Aanpassing meldergroepen magazijn",
      status: "wacht-op-materiaal",
      geplandeDatum: "2026-03-04",
      uitvoerder: "P. van Loon",
    },
    {
      id: "wb-2026-0071",
      werkbonnummer: "WB-2026-0071",
      titel: "NEN 2654 controle logboek",
      status: "afgerond",
      geplandeDatum: "2026-02-22",
      uitvoerder: "M. de Ruijter",
    },
  ],
  documents: [
    {
      id: "doc-1",
      bestandsnaam: "Onderhoudscontract_2026.pdf",
      documenttype: "Contract",
      datumUpload: "2026-02-27",
      gekoppeldAan: "Klantdossier",
    },
    {
      id: "doc-2",
      bestandsnaam: "BMI_Tekeningen_BlokA_v5.pdf",
      documenttype: "Technisch",
      datumUpload: "2026-02-19",
      gekoppeldAan: "Locatie Blok A",
    },
    {
      id: "doc-3",
      bestandsnaam: "RisicoInventarisatie_Inspectie.docx",
      documenttype: "Inspectie",
      datumUpload: "2026-02-13",
      gekoppeldAan: "Werkbon WB-2026-0071",
    },
    {
      id: "doc-4",
      bestandsnaam: "Facturatieafspraken_2026.pdf",
      documenttype: "Financieel",
      datumUpload: "2026-01-30",
      gekoppeldAan: "Facturatie",
    },
  ],
  tasks: [
    {
      id: "task-1",
      titel: "Opdrachtbevestiging Q2 controleren",
      prioriteit: "hoog",
      status: "open",
      deadline: "2026-03-12",
    },
    {
      id: "task-2",
      titel: "Logboek bijlage 4 uploaden",
      prioriteit: "normaal",
      status: "open",
      deadline: "2026-03-15",
    },
    {
      id: "task-3",
      titel: "Facturatiecontact valideren",
      prioriteit: "laag",
      status: "in-behandeling",
      deadline: "2026-03-20",
    },
  ],
  activityFeed: [
    {
      id: "act-1",
      datumTijd: "2026-03-08 10:18",
      actor: "M. Vermeer",
      actie: "Werkbon WB-2026-0142 op in-uitvoering gezet",
    },
    {
      id: "act-2",
      datumTijd: "2026-03-07 15:02",
      actor: "R. de Graaf",
      actie: "Document Onderhoudscontract_2026.pdf geupload",
    },
    {
      id: "act-3",
      datumTijd: "2026-03-06 09:44",
      actor: "Systeem",
      actie: "Signaal: werkbon ouder dan 30 dagen gedetecteerd",
    },
  ],
  signals: [
    {
      id: "sig-1",
      type: "waarschuwing",
      titel: "Open werkbon ouder dan 30 dagen",
      omschrijving: "Werkbon WB-2026-0094 staat al 32 dagen open.",
    },
    {
      id: "sig-2",
      type: "let-op",
      titel: "Documentatie deels incompleet",
      omschrijving: "Installatiehandleiding voor Locatie Blok B ontbreekt.",
    },
    {
      id: "sig-3",
      type: "compliance",
      titel: "Inspectie verloopt binnenkort",
      omschrijving: "NEN 2654 controle verloopt over 11 dagen.",
    },
  ],
  openOpdrachten: [
    { id: "opd-1", naam: "Aanpassing BMI zones verdieping 3", status: "lopend" },
    { id: "opd-2", naam: "Site survey nieuwbouw west", status: "voorbereiding" },
  ],
  portalAccess: {
    summary: {
      status: "invited",
      portalUsersCount: 1,
      primaryPortalContact: { contactId: "ct-1", naam: "Maaike van Dijk", email: "maaike.vandijk@vandijkbrandveiligheid.nl" },
      lastActivityAt: null,
      openPortalAssignments: 0,
      portalUrl: "",
    },
    portalUsers: [
      {
        contactId: "ct-1",
        naam: "Maaike van Dijk",
        email: "maaike.vandijk@vandijkbrandveiligheid.nl",
        role: "opdrachtgever",
        status: "invited",
        portalAccessEnabled: true,
        portalInvitationSentAt: "2026-03-06T09:00:00.000Z",
        portalLastLoginAt: null,
      },
    ],
    availableContacts: [
      {
        contactId: "ct-2",
        naam: "Ruben de Graaf",
        email: "facturen@vandijkbrandveiligheid.nl",
        role: "Financieel medewerker",
        telefoon: "+31 10 345 67 91",
      },
      {
        contactId: "ct-3",
        naam: "Sophie Koster",
        email: "s.koster@vandijkbrandveiligheid.nl",
        role: "Facility coördinator",
        telefoon: "+31 6 80 19 23 11",
      },
    ],
  },
};
